<div class="navigation-container" (click)="onIconClick()">
  <i class="db-icon db-icon-ds-logo-black"></i>
</div>
<db-single-page-creation-step
  [isMobile]="isMobile"
  (formTouched)="formTouched = $event"
  (onNext)="onNext($event)" *ngIf="activeStep === generationSteps.START">
</db-single-page-creation-step>
<ng-container>
  <db-outline-sitemap
    [singlePage]="true"
    (onGenerate)="generate()"
    [isMobile]="isMobile"
    [website]="website"
    [uniqueId]="_builderCommonData.uniqueId"
    [class.hidden]="activeStep !== generationSteps.OUTLINE"
    #sitemap>
  </db-outline-sitemap>
  <div class="db-actions-line" *ngIf="activeStep === generationSteps.OUTLINE && !isMobile">
    <a class="ds-btn-m ds-btn-outline"
       [class.ds-btn-disabled]="_builderInteractionsService.loading|async"
       (click)="onBackClick()">
      <span>{{ 'text_back' | dbText }}</span>
    </a>
    <a class="ds-btn-purple-blue ds-btn-m"
       [class.ds-btn-disabled]="_builderInteractionsService.loading|async"
       (click)="generate()">
      @if (_builderInteractionsService.loading|async) {
        <db-loading-circular-spinner
          [color]="'monochrome'"
          [size]="'xs_small'"
          [newMode]="true"
          class="ml8">
        </db-loading-circular-spinner>
      } @else {
        <i class="db-icon db-icon-ds-ai-generate"></i>
        <span>{{ 'text_generate' | dbText }}</span>
      }
    </a>
  </div>
</ng-container>
<db-single-page-generation-step *ngIf="activeStep === generationSteps.GENERATION">
</db-single-page-generation-step>

